export default "__VITE_ASSET__1ef3ac09__"